<form [formGroup]="berekeningBox1FormGroup">
    <div formGroupName="box1">
        <div formGroupName="opbouwInkomen">
            <div *ngIf="aangifte.verdeling === undefined">
                <div class="row">
                    <div class="col col-1">
                        Inkomsten eigen woning
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="saldoEigenWoning"
                                id="saldoEigenWoning1"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
            <div *ngIf="aangifte.verdeling !== undefined">
                <div class="row">
                    <div class="col col-1">
                        <p>Aandeel inkomsten eigen woning</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="inkomstenUitEigenWoning"
                                id="inkomstenUitEigenWoning"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
            <div *ngIf="berekeningBox1FormGroup.get(['box1', 'opbouwInkomen', 'aftrekWegensGeenOfGeringeEigenWoningSchuld'])?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        <p>Af: Aftrek geen of geringe eigenwoningschuld</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="aftrekWegensGeenOfGeringeEigenWoningSchuld"
                                id="aftrekWegensGeenOfGeringeEigenWoningSchuld"
                                prefix=" € -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </div>
</form>

